import { jsx as r } from "react/jsx-runtime";
const a = ({
  className: e,
  children: o
}) => /* @__PURE__ */ r("thead", { className: e, children: o });
export {
  a as TableHeader
};
//# sourceMappingURL=TableHeader.js.map
